import React, { memo, useCallback } from 'react';
import { defaultChartOptions } from 'services/glass-management/glassManagement';
import { toast } from 'react-toastify';
import GlassCard from '../card/GlassCard';
import { getBarTrendline } from 'helpers/chartjs-utils';
import { themeColors } from 'helpers/utils';
import dayjs from 'dayjs';
import SLAChart from '../SLAChart';
import { useSelector, useDispatch } from 'react-redux';

const Shelled = () => {
    const dispatch = useDispatch();
    const { data, loading, error } = useSelector(s => s.shelled);

    if (error)
        toast.error('Something went wrong!', error);

    const onChartClick = useCallback((e) => {
        if (data?.hasOwnProperty(e?.name)) {
            const tableData = data[e?.name?.toString()]?.map(x => {
                return {
                    ...x,
                    Created: dayjs(x.Created).format('DD-MM-YYYY')
                }
            });

            console.log(tableData);
            // dispatch(openModal({
            //     modalData: tableData,
            //     modalLoading: false,
            //     modalShow: true,
            //     modalTitle: 'BIT',
            //     tableCols: bitCols,
            // }));
        }
    }, [dispatch, data]);

    const getOptions = useCallback(() => {
        const xAxis = data?.map(x => x.key);
        const chartData = xAxis?.map((name, idx) => {
            return {
                value: data[idx]?.jobs?.length,
                name,
                itemStyle: {
                    color: themeColors.success
                }
            };
        });

        return {
            ...defaultChartOptions,
            xAxis: {
                ...defaultChartOptions.xAxis,
                data: xAxis?.map(x => dayjs(x).format('ddd DD'))
            },
            series: [
                {
                    type: 'bar',
                    stack: 'Total',
                    data: chartData,
                },
                {
                    ...defaultChartOptions.series[1],
                    data: getBarTrendline(chartData?.map(x => x.value))
                }
            ],
        }
    }, []);
    const options = getOptions();

    return (
        <GlassCard md={6} lg={4} title="Shelled units" heroValue={{ value: data?.reduce((a, b) => b?.jobs?.length + a, 0) || 0, prefix: '', class: 'text-success' }}>
            <SLAChart loading={loading} options={options} onClick={onChartClick} />
        </GlassCard>
    );
}

export default memo(Shelled);